// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Documentos_HealthcheckResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for healthCheck /documentos/healthCheck
 * Proxy to html2pdf-service health check endpoint
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Documentos_HealthcheckResponseDados = boolean;

export type Documentos_HealthcheckResponse = ApiResponse<Documentos_HealthcheckResponseDados>;

registerResponseContract('Documentos_HealthcheckResponse', {})
